/**
 * Typography tokens — Inter, "Editorial Professional" hierarchy.
 */
export const typography = {
  fontFamily: "'Inter', system-ui, -apple-system, sans-serif",

  display: {
    fontWeight: 700,
    letterSpacing: "-0.02em",
  },

  headline: {
    fontWeight: 600,
    letterSpacing: "-0.02em",
  },

  title: {
    fontWeight: 600,
    letterSpacing: "-0.01em",
  },

  body: {
    fontWeight: 400,
    lineHeight: 1.6,
  },

  label: {
    fontWeight: 500,
    letterSpacing: "0.05em",
    textTransform: "uppercase" as const,
  },
} as const;
